import React from 'react';
import './StepsExplainer_CommunityHomeSection2.css';

const StepsExplainer_CommunityHomeSection2 = ({
  step1 = "Share what kind of people you'd like to meet.",
  step2 = "We'll suggest connections with other members of the community",
  step3 = "If you both express interest, we'll introduce you safely via messenger.",
  light = false
}) => (
  <div className={`steps-container-section2${light ? ' steps-container-section2--light' : ''}`}>
    <div className="step-card-section2">
      <div className="step-number-section2">1</div>
      <div className="step-content-section2">
        <h3>{step1}</h3>
      </div>
    </div>
    <div className="vertical-arrow-section2">↓</div>
    <div className="step-card-section2">
      <div className="step-number-section2">2</div>
      <div className="step-content-section2">
        <h3>{step2}</h3>
      </div>
    </div>
    <div className="vertical-arrow-section2">↓</div>
    <div className="step-card-section2">
      <div className="step-number-section2">3</div>
      <div className="step-content-section2">
        <h3>{step3}</h3>
      </div>
    </div>
  </div>
);

export default StepsExplainer_CommunityHomeSection2;